












// vendor
import { defineComponent } from "@vue/composition-api";
// project
import { RunGallery } from "@/components.run/run-gallery";
// local
import { getProps } from "../../ts/NodeComponent";

type GalleryParams = {};

export default defineComponent({
	
	emits:[
		"end", "previous"
	],
	components:{
		RunGallery,
	},
	props:getProps<GalleryParams>(),
	setup(props, context){

		const onEnd = () => context.emit("end");
		const onBack = () => context.emit("previous");

		return {
			onEnd,
			onBack
		};

	}
});
